package com.clany.backoffice.model

import kotlinx.serialization.Serializable

@Serializable
enum class UserType(val label: String) {
    FREE("FREE"),
    PREMIUM("PREMIUM"),
    TESTER("TESTER")
}

@Serializable
enum class UserStatus(val label: String) {
    ACTIVE("ACTIVE"),
    DELETED("DELETED")
}

@Serializable
enum class UserAuthProvider(val label: String) {
    GOOGLE("GOOGLE"),
    APPLE("APPLE"),
    EMAIL("EMAIL")
}
